"use strict";

var _interopRequireDefault = require("/Users/xudong/bs_workspace/RuoYi-Vue/hss_-warning_-h5/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getToken = getToken;
exports.removeToken = removeToken;
exports.setToken = setToken;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
// const TokenKey =
//   'Bearer eyJhbGciOiJIUzUxMiJ9.eyJqdGkiOiJiY2I3ZDI0NTEzNDk0NGQ2YWUzMjI2M2U0NjZiM2FlZiIsInVzZXIiOiIwMTAyNCIsInN1YiI6IjAxMDI0In0.FWN7R6W8VUA5FCzJBHJGGlULo5khiequjJbQqT2-FJBk6gpTCBUQnDmiWjkp5ErcY2tNLNtVVpvTJOF96SSs9g'
var TokenKey = 'accessToken';
function getToken() {
  return _jsCookie.default.get(TokenKey);
}
function setToken(token) {
  return _jsCookie.default.set(TokenKey, token);
}
function removeToken() {
  return _jsCookie.default.remove(TokenKey);
}